module.exports = "../study/imgs/maps/Tokyo/S8/Climate/Precipitation/Tokyo_Precipitation_HadGEM2_RCP85_Now.png";